import type { TMe } from '@/src/features/auth/models/auth.types'

import type { TLocation } from '../api/types/editAccountSettings.types'

/** Maps `me` location fields to the settings `TLocation` shape when enough data is present. */
export const getMeLocation = (me?: TMe): TLocation | undefined => {
  if (!me?.city || !me.countryCode || me.latitude == null || me.longitude == null) return undefined

  return {
    city: me.city,
    zipcode: me.zipcode,
    countryCode: me.countryCode,
    latitude: me.latitude,
    longitude: me.longitude,
  }
}
